/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs */

const en_admin_membership_confirmations_confirm_modal_subtitle = /** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will start billing the member and send an email notification.`)
};

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs) => LocalizedString} */
const de_admin_membership_confirmations_confirm_modal_subtitle = en_admin_membership_confirmations_confirm_modal_subtitle;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs) => LocalizedString} */
const es_admin_membership_confirmations_confirm_modal_subtitle = en_admin_membership_confirmations_confirm_modal_subtitle;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs) => LocalizedString} */
const fr_admin_membership_confirmations_confirm_modal_subtitle = en_admin_membership_confirmations_confirm_modal_subtitle;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs) => LocalizedString} */
const it_admin_membership_confirmations_confirm_modal_subtitle = en_admin_membership_confirmations_confirm_modal_subtitle;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_confirm_modal_subtitle = en_admin_membership_confirmations_confirm_modal_subtitle;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs) => LocalizedString} */
const pl_admin_membership_confirmations_confirm_modal_subtitle = en_admin_membership_confirmations_confirm_modal_subtitle;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs) => LocalizedString} */
const hu_admin_membership_confirmations_confirm_modal_subtitle = en_admin_membership_confirmations_confirm_modal_subtitle;

/** @type {(inputs: Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs) => LocalizedString} */
const ro_admin_membership_confirmations_confirm_modal_subtitle = en_admin_membership_confirmations_confirm_modal_subtitle;

/**
* | output |
* | --- |
* | "This will start billing the member and send an email notification." |
*
* @param {Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_confirm_modal_subtitle = /** @type {((inputs?: Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_Confirm_Modal_SubtitleInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_confirm_modal_subtitle(inputs)
	if (locale === "de") return de_admin_membership_confirmations_confirm_modal_subtitle(inputs)
	if (locale === "es") return es_admin_membership_confirmations_confirm_modal_subtitle(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_confirm_modal_subtitle(inputs)
	if (locale === "it") return it_admin_membership_confirmations_confirm_modal_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_confirm_modal_subtitle(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_confirm_modal_subtitle(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_confirm_modal_subtitle(inputs)
	return ro_admin_membership_confirmations_confirm_modal_subtitle(inputs)
});
export { admin_membership_confirmations_confirm_modal_subtitle as "admin.membership_confirmations.confirm_modal_subtitle" }